export function directionsUrl(address: string): string {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
}

export function entryDirectionsUrl(entry: { address: string; city: string }): string {
  return directionsUrl(`${entry.address}, ${entry.city}, FL`);
}

export function embedUrl(address: string): string {
  return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
}
